import { MENSAGEM_ACESSO_NEGADO } from "@ida/core";
import { evento, identificar } from "./telemetria.js";

const CODIGOS_LOGIN = new Set([
  "auth/popup-closed-by-user", "auth/cancelled-popup-request",
  "auth/popup-blocked", "auth/network-request-failed",
  "auth/unauthorized-domain", "auth/operation-not-allowed",
  "auth/account-exists-with-different-credential", "auth/user-disabled",
  "auth/too-many-requests", "auth/web-storage-unsupported",
  "auth/internal-error", "permission-denied", "auth/permission-denied",
]);

/** Só códigos conhecidos: mensagens do provedor podem conter dados pessoais. */
export function codigoErroLoginGoogle(erro: unknown): string {
  const codigo = erro && typeof erro === "object" && "code" in erro ? erro.code : undefined;
  return typeof codigo === "string" && CODIGOS_LOGIN.has(codigo) ? codigo : "desconhecido";
}

function cancelado(codigo: string): boolean {
  return codigo === "auth/popup-closed-by-user" || codigo === "auth/cancelled-popup-request";
}

export function mensagemErroLoginGoogle(erro: unknown): string | null {
  const codigo = codigoErroLoginGoogle(erro);
  if (cancelado(codigo)) return null;
  if (codigo === "auth/popup-blocked")
    return "Seu navegador bloqueou a janela do Google. Permita popups para este site e tente de novo.";
  if (codigo === "auth/network-request-failed")
    return "Não conseguimos conectar ao Google. Confira sua conexão e tente de novo.";
  if (["permission-denied", "auth/permission-denied", "auth/user-disabled"].includes(codigo))
    return MENSAGEM_ACESSO_NEGADO;
  return "Não foi possível entrar com Google. Tente de novo.";
}

/** A tentativa começa no clique real; abrir o diálogo continua sendo outro evento. */
export async function loginGoogleMedido<T extends { user: { uid: string } }>(
  autenticar: () => Promise<T>,
  ctaId: string,
): Promise<T> {
  const inicio = Date.now();
  const contexto = {
    origem_login: "dialogo_landing",
    versao_dialogo: "acesso_e_cadastro_v2",
    cta_id: ctaId,
    tentativa_id: globalThis.crypto?.randomUUID?.()
      ?? `${inicio}-${Math.random().toString(36).slice(2)}`,
  };
  evento("login_google_iniciado", contexto);
  let credencial: T;
  try {
    // Não aguardar telemetria antes do popup: preserva o gesto do usuário.
    credencial = await autenticar();
  } catch (erro) {
    const codigo = codigoErroLoginGoogle(erro);
    evento(cancelado(codigo) ? "login_google_cancelado" : "login_google_erro", {
      ...contexto, codigo_erro: codigo, duracao_ms: Date.now() - inicio,
    });
    throw erro;
  }
  identificar(credencial.user.uid);
  // Preserva o evento existente, sem contá-lo novamente na tela.
  evento("login_concluido", { ...contexto, duracao_ms: Date.now() - inicio });
  return credencial;
}
